module.exports = __webpack_public_path__ + "static/media/pc_icon_left_disable.b227b83e.svg";